(function () {
  if (window.IzzatHeroLazyVideo) return;
  window.IzzatHeroLazyVideo = true;

  var SELECTOR = '[data-izzat-hero-video]';
  var WRAPPER_SELECTOR = '[data-izzat-hero-video-wrapper]';
  var INTERACTION_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
  var autoplayScheduled = false;
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var slowConnection = connection && /(^|-)2g$/.test(connection.effectiveType || '');
  var allowAutoplayLoad = !reduceMotion && !(connection && connection.saveData) && !slowConnection;

  function loadVideo(video) {
    if (!video || video.dataset.izzatLoaded === 'true') return;

    var wrapper = video.closest(WRAPPER_SELECTOR);
    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;

    video.dataset.izzatLoaded = 'true';
    video.autoplay = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('autoplay', '');

    sources.forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.addEventListener(
      'canplay',
      function () {
        wrapper && wrapper.classList.add('is-video-ready');
      },
      { once: true }
    );

    video.load();
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function loadVisibleVideos() {
    document.querySelectorAll(SELECTOR).forEach(function (video) {
      var wrapper = video.closest(WRAPPER_SELECTOR) || video;
      var rect = wrapper.getBoundingClientRect();
      var isVisible = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      if (isVisible) loadVideo(video);
    });
  }

  function scheduleAutoplay() {
    if (autoplayScheduled || !allowAutoplayLoad) return;
    autoplayScheduled = true;

    var run = function () {
      window.setTimeout(loadVisibleVideos, 1800);
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 3500 });
    } else {
      run();
    }
  }

  INTERACTION_EVENTS.forEach(function (eventName) {
    window.addEventListener(eventName, loadVisibleVideos, { once: true, passive: true });
  });

  if (document.readyState !== 'loading') {
    scheduleAutoplay();
  }

  window.addEventListener('load', scheduleAutoplay, { once: true });
})();
